import { Component, Input } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
    selector: "app-driveb-master-wrapper",
    templateUrl: "./master-wrapper.component.html",
    styleUrls: ["./master-wrapper.component.scss"],
    standalone: false
})
export class MasterWrapperComponent {
  detailViewMinSize = 448;
  detailViewSize = 448;
  masterViewMinSize: number;
  useDialog = false;
  useResizeHandle = false;
  useSlideoverSidebarMode = false;

  @Input() withDetailView = false;

  constructor(private route: ActivatedRoute, private router: Router) {}

  closeTrigger = (): Promise<boolean> =>
    this.router.navigate(["."], { relativeTo: this.route });
}
